<template>
    <div class="container-fluid my-3 py-3">
        <div class="row my-3">
            <div class="col-6">
                <div class="form-floating">
                    <input id="inputName" ref="name" type="text" name="name" class="form-control"  v-model="organisationDailyReportSubHeader.name" placeholder="name@example.com">
                    <label for="inputName" class="form-label" >{{ $t("name") }}</label>
                </div>
            </div>    
                          
        </div>
        <button class="btn btn-success mb-0 ms-auto" @click="submitForm">{{ $t("save") }}</button>
    </div>
</template>

<script>
import { createToast } from '@/assets/js/myToast.js'
import axios from 'axios'
export default {
    name: 'AddOrganisationDailyReportHeader',
    emits: ['closeModal'],
    props: {
        organisationDailyReportHeader: {
            type: Object,
            required: true,
        },
        subHeaderPosition: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            organisationDailyReportSubHeader: {}
        }
    },
    mounted(){
        console.log('entry mounted')
        this.focusInput()
        console.log('exit mounted')
    },
    methods: {
        focusInput() {
            console.log('entry focusInput')
            console.log(this.$refs.name)
            this.$refs.name.focus();
            console.log('exit focusInput')
        },
        submitForm() {
            this.organisationDailyReportSubHeader.organisation_daily_report_header = this.organisationDailyReportHeader.id
            this.organisationDailyReportSubHeader.created_by = this.$store.state.me.id
            this.organisationDailyReportSubHeader.modified_by = this.$store.state.me.id
            this.organisationDailyReportSubHeader.position = this.subHeaderPosition
            axios
                .post(`/api/v1/organisation_daily_report_subheaders/`, this.organisationDailyReportSubHeader)
                .then(response => {
        
                    createToast({text: this.$t("header added")
                        ,type: 'success'})
                    this.organisationDailyReportSubHeader.name = ''

                this.$emit('closeModal', 'add', response.data)
                })
                .catch(error => {
                    if (error.response) {
                        if ('detail' in error.response.data){
                            createToast({text: this.$t(error.response.data['detail'])
                                        ,type: 'error'})
                        }                        
                        console.error(JSON.stringify(error.response.data))
                    } else if (error.message) {
                        console.error(JSON.stringify(error.message))
                    } else {
                        console.error(JSON.stringify(error))
                    }
                })
        }
    },
    computed:{
    }
}
</script>